/**
 * Auth Layout
 * ===========
 * تخطيط صفحات المصادقة
 */

import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AuthLayout.css';

const AuthLayout = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="watrly-auth-loading">
        <div className="watrly-auth-loading__spinner" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return (
    <div className="watrly-auth">
      <div className="watrly-auth__container">
        {/* Left Side - Branding */}
        <div className="watrly-auth__branding">
          <div className="watrly-auth__branding-content">
            <div className="watrly-auth__logo">
              <svg viewBox="0 0 24 24" className="watrly-auth__logo-icon">
                <path
                  d="M12 2C12 2 6 10 6 14C6 17.3137 8.68629 20 12 20C15.3137 20 18 17.3137 18 14C18 10 12 2 12 2Z"
                  fill="#FFFFFF"
                />
              </svg>
              <span className="watrly-auth__logo-text">وترلي</span>
            </div>
            <h1 className="watrly-auth__title">لوحة تحكم المدير العام</h1>
            <p className="watrly-auth__subtitle">
              إدارة منصة وترلي لتوصيل المياه بكفاءة واحترافية
            </p>

            <div className="watrly-auth__features">
              <div className="watrly-auth__feature">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
                <span>إدارة الشركات والمستأجرين</span>
              </div>
              <div className="watrly-auth__feature">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
                <span>مراقبة العمليات والطلبات</span>
              </div>
              <div className="watrly-auth__feature">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
                <span>تحليلات وتقارير متقدمة</span>
              </div>
            </div>
          </div>

          <div className="watrly-auth__branding-footer">
            © 2026 وترلي - جميع الحقوق محفوظة
          </div>
        </div>

        {/* Right Side - Form */}
        <div className="watrly-auth__form-container">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
